import { dictionary } from '../../engine/dictionary';
import type { PuzzleMode } from '../../engine/types';
import { TrellisBoard } from './Board';
import {
  TRELLIS_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  makeHint,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type TrellisConfig,
  type TrellisMove,
  type TrellisState,
} from './logic';

export const trellisMode: PuzzleMode<TrellisState, TrellisMove, TrellisConfig> = {
  id: 'trellis',
  name: 'Trellis',
  tagline: 'Climb word to word',
  description:
    'Climb from the start word to the target, changing one letter at a time. Every rung must be a real word.',
  accent: 'vine',
  glyph: 'ladder',
  howToPlay: [
    { title: 'Change one letter', body: 'Each word must differ from the one before it by exactly one letter.' },
    { title: 'Stay a real word', body: 'Every rung has to be a valid word — no nonsense in between.' },
    { title: 'Reach the target', body: 'Climb to the target word before you run out of rungs.' },
  ],
  difficulties: TRELLIS_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove: (state, move) => {
    const base = validateMove(state, move);
    if (!base.ok) return base;
    if (move.type === 'submit' && !dictionary.isValid(state.current)) {
      return { ok: false, reason: 'Not in word list' };
    }
    return { ok: true };
  },
  handleKey,
  hint: (state) => makeHint(state, dictionary),
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: TrellisBoard,
};
